<ion-app>
  <ion-router-outlet>
    <robex-activity-indicator />
  </ion-router-outlet>
</ion-app>
